import { render, staticRenderFns } from "./BchSubscriptionBilling.vue?vue&type=template&id=781d5182&scoped=true"
import script from "./BchSubscriptionBilling.vue?vue&type=script&lang=js"
export * from "./BchSubscriptionBilling.vue?vue&type=script&lang=js"
import style0 from "./BchSubscriptionBilling.vue?vue&type=style&index=0&id=781d5182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781d5182",
  null
  
)

export default component.exports